import { useMutation } from "@tanstack/react-query";
import { apiPatch } from "../client";

interface UpdateExamProgressAnswersParams {
  progressId: string;
  examPaperId: string;
  answers: {
    question_id: string;
    selected_answer: string;
  }[];
}

interface UpdateExamProgressAnswersRequest {
  answers: {
    question_id: string;
    selected_answer: string;
  }[];
}

export function useMutationUpdateExamProgressAnswers() {
  return useMutation({
    mutationFn: async ({
      progressId,
      examPaperId,
      answers,
    }: UpdateExamProgressAnswersParams) => {
      const request: UpdateExamProgressAnswersRequest = {
        answers,
      };
      const res = await apiPatch<unknown>(
        `/exam_progress/${progressId}/exam_papers/${examPaperId}/answers`,
        request
      );
      return res;
    },
  });
}

export type { UpdateExamProgressAnswersParams };
